export default "__VITE_ASSET__CKZBuxqA__"